import { render, staticRenderFns } from "./showEntrepreneurshipListConvocationFormAdmin.vue?vue&type=template&id=21537d61"
import script from "./showEntrepreneurshipListConvocationFormAdmin.vue?vue&type=script&lang=js"
export * from "./showEntrepreneurshipListConvocationFormAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports